<template>
    <div class="course-comment" style="min-height: 100vh">
        <div class="course-comment-title">
            <div class="title-left">
                <div class="icon"></div>
                <p class="text">课程评论</p>
            </div>
            <div class="title-right">
                <el-button class="btn" size="small"
                    @click="commentHandle('comment', bbsInfo.subtitle, 0, 0, null, null)">发布评论</el-button>
            </div>
        </div>
        <div class="comment-header" v-show="!noDataShower">
            <div class="header-left">
                <p class="comment-total">{{ bbsInfo.reply_num }}条评论</p>
            </div>
            <div class="header-right">
                <el-button type="text" @click="changeSort()">
                    <i class="iconfont icon-paixu3"></i>
                    <span>{{ replyOrder === 'praise_num' ? '切换为时间排序' : '切换为默认排序' }}</span>
                </el-button>
            </div>
        </div>
        <div class="comment-content">

            <ul class="comment-list border-box" v-if="commList.length > 0">
                <li class="comment-item" v-for="(comm, ind) in commList" :key="ind">
                    <div class="comment-main">

                        <div class="comment-main-header">
                            <div class="comment-main-header-left">
                                <div class="user-avatar">
                                    <el-avatar :size="24" :src="comm.headimgurl"></el-avatar>
                                </div>
                                <div class="user-name">{{ comm.uname }}</div>
                            </div>
                            <div class="comment-main-header-right">
                                <p class="comment-date">{{ comm.createtime }}</p>
                            </div>
                        </div>
                        <div class="comment-info">
                            <div class="user-comment">
                                <mavon-editor class="md" :value="comm.content" :subfield="false"
                                              defaultOpen='preview' placeholder="" :editable="false" :toolbarsFlag="false"
                                              :ishljs="true" :boxShadow="false" style="min-height: 1px;padding: 0;"
                                              :previewBackground="previewStyle" :codeStyle="mavonCodestyle"></mavon-editor>
                            </div>
                            <div class="operate">
                                <div class="operate-item" @click="circleOperate('reply', comm, ind, 'praise', null)"
                                     :class="{ 'active': comm.my_praise == 1 }">
                                    <i class="iconfont icon-dianzan"></i>
                                    <span>{{ comm.praise_num }}</span>
                                </div>
                                <div class="operate-item" @click="circleOperate('reply', comm, ind, 'down', null)"
                                     :class="{ 'active': comm.my_praise == 2 }">
                                    <i class="iconfont icon-dianzan1-copy"></i>
                                    <span>{{ comm.down_num }}</span>
                                </div>
                                <div class="operate-item" v-if="!comm.isopen && comm.reply_num > 0"
                                     @click="openReply(comm, ind)">
                                    <i class="iconfont icon-pinglunyuhuifuxuanzhong"></i>
                                    <span>查看{{ comm.reply_num }}条回复</span>
                                </div>
                                <div class="operate-item" v-if="comm.isopen" @click="closeReply(comm, ind)">
                                    <i class="iconfont icon-pinglunyuhuifuxuanzhong"></i>
                                    <span>收起回复</span>
                                </div>
                                <div class="operate-item hide-item"
                                     @click="commentHandle('reply', comm.uname, comm.replyid, 0, ind, null)">
                                    <i class="iconfont icon-yihuifu"></i>
                                    <span>回复</span>
                                </div>
                                <div class="operate-item hide-item" v-if="comm.is_myreply == 1"
                                     @click="commentHandle('comm', bbsInfo.subtitle, 0, comm.replyid, ind, null)">
                                    <i class="iconfont icon-edit-fill"></i>
                                    <span>编辑</span>
                                </div>
                                <div class="operate-item hide-item" v-if="comm.is_myreply == 1"
                                     @click="delComments(comm.replyid, null, null)">
                                    <i class="iconfont icon-shanchu1"></i>
                                    <span>删除</span>
                                </div>
                            </div>
                        </div>

                    </div>
                    <el-collapse-transition>
                        <div class="reply-list" v-show="comm.isopen">
                            <ul class="comment-list">
                                <li class="comment-item" v-for="(reply, index) in comm.replyList" :key="index">
                                    <div class="comment-main">
                                        <div class="comment-main-header">
                                            <div class="comment-main-header-left">
                                                <div class="user-avatar">
                                                    <el-avatar :size="24" :src="reply.headimgurl"></el-avatar>
                                                </div>
                                                <div class="user-name">{{ reply.uname }}</div>
                                            </div>
                                            <div class="comment-main-header-right">
                                                <p class="comment-date">{{ comm.createtime }}</p>
                                            </div>
                                        </div>
                                        <div class="comment-info">
                                            <div class="user-comment">
                                                <mavon-editor class="md" :value="reply.content" :subfield="false"
                                                              defaultOpen='preview' placeholder="" :editable="false"
                                                              :toolbarsFlag="false" :ishljs="true" :boxShadow="false"
                                                              style="min-height: 1px;padding: 0;"
                                                              :previewBackground="previewStyle"
                                                              :codeStyle="mavonCodestyle"></mavon-editor>
                                            </div>
                                            <div class="operate">
                                                <div class="operate-item"
                                                     @click="circleOperate('reply', reply, index, 'praise', ind)"
                                                     :class="{ 'active': reply.my_praise == 1 }">
                                                    <i class="iconfont icon-dianzan"></i>
                                                    <span>{{ reply.praise_num }}</span>
                                                </div>
                                                <div class="operate-item"
                                                     @click.stop="circleOperate('reply', reply, index, 'down', ind)"
                                                     :class="{ 'active': reply.my_praise == 2 }">
                                                    <i class="iconfont icon-dianzan1-copy"></i>
                                                    <span>{{ reply.down_num }}</span>
                                                </div>
                                                <div class="operate-item hide-item" v-if="reply.is_myreply == 1"
                                                     @click="commentHandle('reply', comm.uname, 0, reply.replyid, ind, index)">
                                                    <i class="iconfont icon-edit-fill"></i>
                                                    <span>编辑</span>
                                                </div>
                                                <div class="operate-item hide-item" v-if="reply.is_myreply == 1"
                                                     @click="delComments(reply.replyid, comm, ind)">
                                                    <i class="iconfont icon-shanchu1"></i>
                                                    <span>删除</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                                <div class="page">
                                    <MyPage style="margin-top: 10px;"
                                        :pagination="{ page: comm.replypage, size: replySize, total: comm.reply_num }"
                                        @currentChange="(currentPage) => { reply_current_change(comm, ind, currentPage) }" />
                                </div>
                            </ul>
                            <div class="fold-reply">
                                <p @click="closeReply(comm, ind)">收起回复</p>
                            </div>
                        </div>
                    </el-collapse-transition>

                </li>
            </ul>
            <NoData v-if="noDataShower" :noDataBoxText="'暂无评论'" style="margin: 15vh 0;"></NoData>
            <div class="page">
                <MyPage style="margin-top: 10px;" :pagination="pagination1" @currentChange="commentCurrentChange" />
            </div>
        </div>

        <!-- 评论&回复 -->
        <el-drawer :visible.sync="dialogComment" append-to-body :modal="true" :close-on-press-escape="true"
            :wrapperClosable="true" :size="drawerSize" direction="btt" custom-class="drawerDisCussClass"
            :with-header="false">
            <reply ref="replyE" v-if="dialogComment" @cancelReply="cancelReply" @confirmReply="confirmReply"></reply>
        </el-drawer>

    </div>
</template>

<script>
import { mavonEditor } from 'mavon-editor';
import discuss from "@/page/Public/Exchange/discuss.vue";
import reply from "@/page/Public/Exchange/replay.vue";
import 'highlight.js/styles/atelier-lakeside-dark.css';
import 'highlight.js/styles/github.css';
import { postAjax } from "@/api";
import { isLogin } from "@/api/isLogin";
import highLightUtil from '../../../../static/utils/highLightUtil.js';

import NoData from '@/components/NoData/noData.vue';
export default {
    name: 'CourseComment',
    components: {
        mavonEditor, discuss, reply,NoData
    },
    props: {
        spaceid: "",
        subid: "",
    },
    data() {
        return {
            bbsid: '',
            params: this.$route.params,
            replyOrder: 'praise_num', // praise_num 默认排序  createtime 时间排序
            bbsInfo: {},
            commList: [], // 评论列表
            // 评论的分页
            pagination1: {
                total: 0,
                page: 1,
                size: 20
            },
            dialogComment: false,


            drawerSize: '45%',
            previewStyle: this.themeVal == 'black' ? '#2f3244' : '',
            mavonCodestyle: this.themeVal == 'black' ? 'atelier-lakeside-dark' : 'github',


            discussDrawer: false,

            noDataShower: true,
            fullWidth: '',

            replySize: 10,

        }
    },
    created() {
        this.getBbsInfo();

    },
    methods: {
        // 更改排序方式
        changeSort() {
            this.replyOrder = this.replyOrder === 'praise_num' ? "createtime" : "praise_num";
            this.getComments();
        },
        getBbsInfo() {
            this.commList = [];
            postAjax("/bbs/getBbsInfo", { spaceid: this.spaceid, subid: this.subid }).then((res) => {
                this.bbsInfo = res.data
                this.bbsid = this.bbsInfo.bbsid
                this.getComments();
                this.logPvUv();
                highLightUtil.highLight()
            })
        },
        // 获取评论列表
        getComments() {
            this.commList = [];
            postAjax("/bbs/replyList", { type: 'discuss', bbsid: this.bbsid, page: this.pagination1.page, size: this.pagination1.size, order: this.replyOrder }).then((res) => {
                this.commList = res.data.items;
                this.pagination1.page = res.data.page;
                this.pagination1.total = res.data.count;
                if (this.commList.length > 0) {
                    this.noDataShower = false;
                } else {
                    this.noDataShower = true;
                }
            })
        },
        logPvUv() {
            postAjax("/bbs/logPvUv", { bbsid: this.bbsid });
        },
        commentCurrentChange(val) {
            this.pagination1.page = val;
            this.getComments();
        },
        // 获取回复列表
        getReplys(comm, ind) {
            if (!comm.replypage) comm.replypage = 1;

            postAjax("/bbs/replyList", { type: 'reply', replyid: comm.replyid, page: comm.replypage, size: this.replySize }).then((res) => {
                comm.replyList = res.data.items;
                comm.replypage = res.data.page;
                comm.reply_num = res.data.count

                this.$set(this.commList, ind, comm);
                this.$forceUpdate();

                if (comm.reply_num == 0 && res.data.page == 1) {
                    this.closeReply(comm, ind); //收起回复
                }

            })
        },
        reply_current_change(comm, ind, currentPage) {
            comm.replypage = currentPage;
            this.$set(this.commList, ind, comm);
            this.getReplys(comm, ind);
        },

        // 点赞或者点踩
        circleOperate(type, item, index, optype, ind) {
            postAjax("/bbs/bbsOperate", { type: type, bbsid: item.bbsid, replyid: item.replyid, optype: optype }).then((res) => {
                if (res.code == 1) {
                    item.praise_num = res.data.praise_num;
                    item.down_num = res.data.down_num;
                    item.like_num = res.data.like_num;
                    item.collect_num = res.data.collect_num;
                    item.my_praise = res.data.my_praise;
                    item.my_like = res.data.my_like;
                    item.my_collect = res.data.my_collect;
                }

                if (type == "discuss") {
                    //主贴操作
                    this.bbsInfo = item;
                } else if (type == "reply") {
                    if (ind != null) {
                        this.$set(this.commList[ind].replyList, index, item);
                    } else {
                        this.$set(this.commList, index, item);
                    }
                }
                this.$forceUpdate();
            });
        },


        // 发布评论
        commentHandle(type, userName, pid, replyid, ind, index) {
            let islogin = isLogin()
            if (!islogin) return;
            if (this.$store.state.reply_status == 2) {
                this.$message({
                    message: replyid ? this.$t('Current account has no edit comment permission temporarily!') : this.$t('Current account has no comment permission temporarily!'),
                    type: 'warning'
                });
                return
            }
            this.dialogComment = true;
            let content = "";
            if (replyid > 0 && index == null) {
                content = this.commList[ind].content;
            } else if (replyid > 0 && index != null) {
                content = this.commList[ind].replyList[index].content;
            }
            this.$nextTick(() => {
                this.$refs.replyE.setUserName(userName);
                this.$refs.replyE.setCommForm({ bbsid: this.bbsInfo.bbsid, replyid: replyid, pid: pid, content: content });
                this.$refs.replyE.setReplyData({ ind: ind, index: index })
            })
        },

        //编辑评论
        editComment(type) {
            this.dialogComment = true;
            this.$nextTick(() => {
                if (type == 'reply') {
                    this.$refs.replyE.typeName = this.$t('Reply');
                    this.$refs.replyE.btnName = this.$t('Submit1');
                } else {
                    this.$refs.replyE.typeName = this.$t('comments');
                    this.$refs.replyE.btnName = this.$t('Submit1');
                }
            })
        },
        //取消评论
        cancelReply() {
            this.dialogComment = false;
        },
        //删除评论
        delComments(replyid, comm, ind) {
            this.$confirm(this.$t('Deleted data cannot be restored. Are you sure you want to delete it?'), this.$t('Prompt'), { confirmButtonText: this.$t('Delete'), cancelButtonText: this.$t('Cancel'), type: 'error' }).then(() => {
                postAjax("/bbs/delReply", { replyid: replyid }).then(async (res) => {
                    if (res.code == 1) {
                        this.$message({ type: 'success', message: this.$t('Successfully deleted'), duration: 2000 });

                        if (comm != null) {
                            //删除的是回复
                            if (comm.replyList.length == 1 && comm.replypage > 1) {
                                comm.replypage = 1;
                            }
                            this.getReplys(comm, ind);

                        } else {
                            //删除的是评论
                            if (this.commList.length == 1 && this.commPage > 1) {
                                this.commPage = 1;
                            }
                            this.bbsInfo.reply_num > 0 ? this.bbsInfo.reply_num-- : 0;
                            this.getComments();
                        }
                    } else {
                        this.$message({ type: 'error', message: res.msg, duration: 2000 });
                    }
                })
            }).catch(() => { });
        },

        //回复成功确认弹框
        confirmReply(commForm, replyData) {
            this.dialogComment = false;

            if (commForm.replyid > 0) {
                //修改成功
                if (replyData.index == null) {
                    //评论
                    this.commList[replyData.ind].content = commForm.content;
                } else {
                    this.commList[replyData.ind].replyList[replyData.index].content = commForm.content;
                }

            } else {
                //新增成功
                if (replyData.ind == null) {
                    //评论
                    this.commPage = 1;
                    this.bbsInfo.reply_num++;
                    this.getComments(); //获取评论列表
                } else {
                    //回复
                    this.commList[replyData.ind].replypage = 1;
                    this.openReply(this.commList[replyData.ind], replyData.ind) //获取评论的回复列表
                }

            }

        },

        openReply(item, index) {
            item.isopen = true;
            this.getReplys(item, index);
            this.$set(this.commList, index, item);
        },
        closeReply(item, index) {
            item.isopen = false;
            this.$set(this.commList, index, item);
        },

    }
}
</script>

<style lang="scss" scoped>
.course-comment {
    --size16: 16px;
    --size15: 15px;
    --size14: 14px;
    --size12: 12px;
    --size24: 24px;
    --spacing20: 20px;
    --spacing30: 30px;
    --commonHeight: 20px;

    .course-comment-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: var(--spacing20);

        .title-left {
            display: flex;

            .icon {
                width: calc(var(--commonHeight) * 2.514);
                height: calc(var(--commonHeight) * 2.0505);
                background: url('../../../../static/img/courseDetail_icon4.png') no-repeat;
                background-size: cover;
                background-position: center;
            }

            .text {
                font-family: YouSheBiaoTiHei, YouSheBiaoTiHei;
                font-weight: 400;
                font-size: var(--size24);
                color: #202020;
                position: relative;
                top: calc(var(--commonHeight) * 0.1);
                margin-left: calc(var(--commonHeight) * 0.3);
                height: fit-content;

                &::after {
                    content: '';
                    position: absolute;
                    left: calc(var(--commonHeight) * -0.8);
                    bottom: calc(var(--commonHeight) * -0.1);
                    width: calc(var(--commonHeight) * 9.15);
                    height: calc(var(--commonHeight) * 0.1);
                    background: linear-gradient(90deg, #FF8E2A 0%, #FFFFFF 100%);
                }

                &::before {
                    content: '';
                    position: absolute;
                    left: calc(var(--commonHeight) * -0.8);
                    bottom: calc(var(--commonHeight) * -0.5);
                    width: calc(var(--commonHeight) * 9.15);
                    height: calc(var(--commonHeight) * 0.3);
                    background: linear-gradient(90deg, #FF8E2A 0%, #FFFFFF 100%);
                }
            }
        }

        .title-right {
            .btn {
                background-color: #FF8E2A;
                color: white;
                border-color: #FF8E2A;
                border-radius: 4px;
                height: calc(var(--commonHeight) * 1.6);
                line-height: 0;
            }
        }
    }

    .comment-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eee;
        .header-left {
            .comment-total {
                font-size: var(--size14);
                font-weight: bold;
                color: #333;
            }
        }

        .header-right {
            .el-button--text {
                color: #666;
                font-size: var(--size14);
            }
        }
    }

    .comment-content {
        overflow: hidden;
        min-height: 76px;
        padding: 10px;

        .border-box {
            border-radius: 4px;
        }

        .comment-list {
            box-sizing: border-box;

            .comment-item {
                border-bottom: 1px solid #eee;

                &:nth-last-child(1) {
                    border-bottom: none;
                }

                .comment-main {

                    padding: var(--spacing20) 0;
                    gap: var(--spacing30);

                    &:hover {
                        .comment-info {
                            .operate {
                                .hide-item {
                                    display: flex;
                                }
                            }
                        }
                    }
                    .comment-main-header {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .comment-main-header-left {
                            display: flex;
                            align-items: center;
                            .user-avatar {
                                width: 24px;
                                height: 24px;
                                margin-right: 8px;
                                img:{
                                    height:100%
                                }
                            }
                            .user-name {
                                font-size: var(--size15);
                                color: #333;
                            }
                        }

                        .comment-main-header-right {
                            .comment-date {
                                font-size: var(--size14);
                                color: #666;
                                white-space: nowrap;
                            }
                        }

                    }

                    .comment-info {
                        padding-top: 5px;
                        padding-left: 32px;
                        box-sizing: border-box;
                        .user-comment {
                            /deep/ .md {
                                padding: 0;
                                margin: 0;
                                background: none;
                                border: none;
                                box-shadow: none;

                                .v-show-content,
                                .v-show-content-html {
                                    padding: 0;
                                    margin: 0;
                                    background: none;
                                }
                            }
                        }
                        .operate {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 20px;

                            .operate-item {
                                display: flex;
                                align-items: center;
                                gap: 5px;
                                font-size: var(--size12);
                                color: #999;
                                cursor: pointer;

                                &:hover {
                                    color: #666;
                                }

                                &.active {
                                    color: #FF8E2A;
                                }
                            }

                            .hide-item {
                                display: none;
                            }
                        }
                    }


                }

                .reply-list {
                    overflow: hidden;
                    padding: 0 var(--spacing20);

                    .comment-list {
                        .comment-item {
                            border-bottom: 1px solid #eee;

                            &:nth-child(1) {
                                border-top: 1px solid #eee;
                            }
                        }
                    }

                    .fold-reply {
                        text-align: center;
                        padding: 10px;
                        margin: 0 var(--spacing20);
                        cursor: pointer;
                        color: #999;

                        &:hover {
                            color: #666;
                        }
                    }
                }
            }
        }

        .no-comment {
            font-size: var(--size12);
            color: #999;
            text-align: center;
            margin: 30px 0;
        }

        .page {
            display: flex;
            justify-content: center;
        }
    }
}

@media screen and (max-width: 1600px) {
    .course-comment {
        --commonHeight: 17px;
        --size24: 20px;
        --size16: 14px;
        --size15: 13px;
        --size14: 12px;
        --size12: 12px;
        --spacing20: 20px;
        --spacing30: 30px;
    }
}

@media screen and (max-width: 1440px) {
    .course-comment {
        --commonHeight: 15px;
        --size24: 18px;
    }
}

@media screen and (max-width: 1299px) {
    .course-comment {
        --size24: 16px;
    }
}

@media screen and (max-width: 1000px) {
    .course-comment {
        --commonHeight: 13px;
    }
}

@media screen and (max-width: 800px) {
    .course-comment {
        --commonHeight: 10px;
    }
}

@media screen and (max-width: 768px) {
    .course-comment {
        --size24: 13px;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/Public/CoursePack/CourseComment.vue